import React, { useState } from "react";
import { siteConfig } from "../../config/siteConfig";

const CTASection = ({ onCtaClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { uiCopy, contact } = siteConfig;
  const cta = uiCopy.cta;

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-700" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full filter blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 md:p-16 border border-white/20">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">{cta.finalSectionTitle}</h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">{cta.finalSectionSubtitle}</p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={onCtaClick} className="group px-8 py-4 bg-white text-emerald-600 text-lg font-bold rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all flex items-center justify-center gap-2">
              <span>{cta.finalSectionPrimary}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
            <button onClick={() => setIsModalOpen(true)} className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border-2 border-white/40 text-lg font-bold rounded-2xl hover:bg-white/30 hover:border-white/60 transition-all">
              {cta.finalSectionSecondary}
            </button>
          </div>
          <p className="text-sm text-white/70 mt-8">{cta.finalSectionFooter}</p>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={() => setIsModalOpen(false)} />
          <div className="relative bg-white rounded-3xl p-8 md:p-12 max-w-md w-full shadow-2xl animate-in fade-in zoom-in duration-300">
            <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 transition-colors">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-2xl font-black text-slate-900 mb-2">Contacto de Ventas</h3>
              <p className="text-slate-500 mb-8">¿Tienes dudas o necesitas ayuda? Escríbenos directamente:</p>
              <a href={`mailto:${contact.salesEmail}`} className="block w-full py-4 bg-slate-100 rounded-2xl text-xl font-black text-emerald-600 hover:bg-emerald-50 transition-colors border-2 border-dashed border-emerald-200 mb-6">
                {contact.salesEmail}
              </a>
              <button onClick={() => setIsModalOpen(false)} className="text-sm font-bold text-slate-400 hover:text-slate-600 transition-colors">
                Cerrar ventana
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CTASection;
